import { Injectable } from '@angular/core';
import { en } from '../../../environments/environment.tok'
import * as forge from 'node-forge';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MakingDataService {

  constructor() {

  }

  async dataE(data: any) {
    let k=en.temppu.substring(1,en.temppu.length-1)
    const pK = forge.pki.publicKeyFromPem(k.split('\\n').join('\n'));
    let chunkSize = 214
    const chunks: any = [];
    let dataToencrypt = data instanceof  String ? data:JSON.stringify(data)

    for (let i = 0; i < dataToencrypt.length; i += chunkSize) {
      const chunk = dataToencrypt.substring(i, i + chunkSize);
      const encryptedChunk = pK.encrypt(chunk, 'RSA-OAEP')
      chunks.push(JSON.stringify(encryptedChunk));
    }
    return forge.util.encode64(JSON.stringify(chunks))

  }

  async dataD(data: any) {
    let k=en.temppa.substring(1,en.temppa.length-1)
    const pK = forge.pki.privateKeyFromPem(k.split('\\n').join('\n'));
    let dataToEncrypt = forge.util.decode64(data['data'])
    let decryptedData = '';
    for (let encryptedChunk of JSON.parse(dataToEncrypt)) {
      const decryptedChunk = pK.decrypt(JSON.parse(encryptedChunk), 'RSA-OAEP');
      decryptedData += decryptedChunk;
    }
    if (data['error'] == false) { 
      try{
        data['data'] = JSON.parse(decryptedData) 
      }catch(error){
        data['data']=decryptedData
      }
    }else {
      data['data'] = decryptedData
    }
    return data

  }
  
  
  

}
